<template>
    <div class="row">
        <div class="col" v-show="!pinModal">
            <div class="form-group" :class="{ 'form-group--error': $v.salary.$error}">
                <label for="first_name">{{'Salary' | trans}}</label>
                <input type="text" class="form-control" v-model="salary" id="first_name"
                       :class="status($v.salary)"
                       :disabled="loading">
                <ul class="invalid-feedback list-unstyled" v-if="$v.salary.$error">
                    <li v-if="!$v.salary.required">
                        {{'This field is required' | trans}}
                    </li>
                </ul>
                <form-errors :field-name="'salary'" />
            </div>

            <div class="form-group">
                <label for="organization">{{'Currency' | trans}}</label>
                <select-group v-model="C_Currency_ID" :list="allCurrencies" :fieldValue="'C_Currency_ID'"
									:fieldText="'Name'"
									id="s_currency" name="s_currency"
									:className="status($v.C_Currency_ID)">
						<option selected value="">-- {{'Currency' | trans}} --</option>
						<template slot="after">
							<ul class="currency__messages invalid-feedback list-unstyled"
								v-if="$v.C_Currency_ID.$error">
								<li v-if="!$v.C_Currency_ID.required">
									{{'This field is required' | trans}}
								</li>
							</ul>
						</template>
					</select-group>
                <form-errors :field-name="'C_Currency_ID'" />
            </div>
            <div class="form-group">
                <spinner-button class="btn btn-danger" @click="pinModal=true" :is-pending="loading" :disabled="disableSubmitButton">
                    {{'Update' | trans}}
                </spinner-button>
            </div>
        </div>
        <b-modal v-if="pinModal" v-model="pinModal" lazy centered hide-footer hide-header>
			<pin-group v-model="pin" :v="$v.pin" :lock="isPendingPin" :hide-pin-button="hidePinButton"
			           @pinDialogSubmit.self.stop.prevent="editSalary">
				<template slot="header">
					<p>{{'Enter Your Pin' | trans}}</p>
				</template>
			</pin-group>
		</b-modal>
    </div>
</template>

<script>
    const { required, minLength, maxLength, integer } = require('vuelidate/lib/validators');
    import { validationMixin } from 'vuelidate';
    import { mapGetters, mapActions } from 'vuex';

    export default {
    name: "edit-salary-employee",
    props: ['route', 'landingRoute', 'employees', 'defaultCountry'],
    mixins: [validationMixin],
    data() {
        return {
            disableSubmitButton: false,
            pinModal:false,
            loading:false,
            pin:'',
            salary:'',
            C_Currency_ID:'',
            employee:[],
            isPendingPin:false,
            hidePinButton:false
        }
    },
    async mounted(){
        try {
            console.log(this.employees)
            this.EventBus.$on("editEmployee", () => {
                this.employees.forEach(element => {
                    if(element.phone == this.$root.currentPhone){
                        this.employee = element;
                        this.id = element.salary_id;
                        this.salary = element.montant;
                        this.C_Currency_ID = element.currencyId;
                    }
                });
            });

            this.employees.forEach(element => {
                if(element.paye_id == this.$root.currentPhone){
                    this.employee = element;
                    this.id = element.salary_id;
                    this.salary = element.montant;
                    this.C_Currency_ID = element.currencyId;
                }
            });

        } catch (error) {
            console.log(error);
        }
    },
    computed: {
	    ...mapGetters("Application", ["currenciesByCountry"]),
        allCurrencies() {
            return this.currenciesByCountry(this.defaultCountry);
        },
	},
    methods: {
        editSalary(){
                this.isPendingPin = true;
                axios.post(this.route, {
                    pin: this.pin,
                    salary: this.salary,
                    C_Currency_ID: this.C_Currency_ID,
                    employee:this.employee
                })
                .then((response) => {
                    this.pinModal = false
                    this.EventBus.$emit("event-success", Lang.get("Success"));
                    location.reload();
                })
                .finally(() => this.isPendingPin = false);
            }
        },
        validations() {
            let v = {
                    salary: {
                        required
                    },
                    C_Currency_ID: {
                        required
                    },
                pin: {
                    required,
                    minLength: minLength(4),
                    maxLength: maxLength(4),
                    integer
                }
            };
            return v;
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/edit-salary-employee.vue